import { call } from 'redux-saga/effects';
import { fetchConsentsPdf } from '../../api/download';

export function* getConsentsPdfSaga(action) {
    try {
        const response = yield call(fetchConsentsPdf, action.path);
        const file = new Blob([response.data], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.location.href = fileURL;
    } catch (error) {
        console.log(error);
    }
}
